import type {AdminPage} from './admin';
import type {AdminWordlist, AdminWordlistDetail} from './adminWordlists';
import type {
  AdminWordlistDbRow,
  AdminWordlistDetailResponse,
  AdminWordlistListResponse,
  AdminWordlistListRow,
} from '../backend-types/wordlist-admin-api';

/** Shared by the list row (no `words`) and the write-response row (raw `words` string). */
export const toAdminWordlist = (row: AdminWordlistListRow | AdminWordlistDbRow): AdminWordlist => ({
  id: row.id,
  userId: row.user_id,
  name: row.name,
  description: row.description,
  wordCount: row.word_count,
  isPublic: row.is_public,
  isOfficial: row.is_official,
  isDeleted: row.is_deleted,
  createdAt: row.created_at,
  updatedAt: row.updated_at,
});

export const toAdminWordlistPage = (data: AdminWordlistListResponse): AdminPage<AdminWordlist> => ({
  items: data.wordlists.map(toAdminWordlist),
  total: data.total,
  limit: data.limit,
  offset: data.offset,
});

export const toAdminWordlistDetail = (data: AdminWordlistDetailResponse): AdminWordlistDetail => ({
  ...toAdminWordlist(data),
  words: data.words,
  owner: data.owner,
});
